module.exports = __webpack_public_path__ + "assets/img/compound.e7930f17.svg";